import { useQuery } from '@tanstack/react-query'
import { getUserInfo } from './userApi'
import { getUserID } from '../../../utils'
import { useDispatch, useSelector } from 'react-redux'

export const useUserInfo = () => {
    const userID = getUserID()
    const dispatch = useDispatch()
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated)

    const {
        data: user,
        refetch: getUser,
        isLoading,
    } = useQuery({
        queryKey: ['user', userID],
        queryFn: () => getUserInfo(userID, dispatch),
        enabled: !!userID && isAuthenticated,
    })

    return {
        user: user || {},
        loadingUser: isLoading,
        getUser,
    }
}
